import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { generateModuleConfig } from './config.provider';
import { IConfig } from './core/src/interfaces/config.interface';

/**
 * Módulo de Comunicação com o Caronte
 */
@NgModule({
  imports: [
    HttpClientModule,
    CommonModule,
  ],
})
export class CharonModule {
  static withConfig(config: IConfig): ModuleWithProviders<CharonModule> {
    return {
      ngModule: CharonModule,
      providers: generateModuleConfig(config),
    };
  }
}
